import { render, staticRenderFns } from "./CaseDocuments.vue?vue&type=template&id=bf8d5e48"
import script from "./CaseDocuments.vue?vue&type=script&lang=js"
export * from "./CaseDocuments.vue?vue&type=script&lang=js"
import style0 from "./CaseDocuments.vue?vue&type=style&index=0&id=bf8d5e48&prod&lang=scss"
import style1 from "./CaseDocuments.vue?vue&type=style&index=1&id=bf8d5e48&prod&stylus=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports